import Base from './components/Base'
import CriteriaItem from './components/CriteriaItem'
import Display from './components/Display'
import Link from './components/Link'

const Rating = {
  Base,
  CriteriaItem,
  Display,
  Link,
}

export default Rating
